<template>
  <p class="name" v-html="filter.show_only.name" v-if="selectable === false && filter.show_only?.name"></p>
  <p class="name with-ruby" v-else-if="!isLastChild || (isLastChild && showKanaLastChild)">
    <ruby>
      {{ filter?.name }}
      <rt>{{ filter?.extra_fields?.kana }}</rt>
    </ruby>
  </p>
  <p class="name" v-html="filter.name" v-else></p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
/**
 * 絞り込みに読み仮名を追記するために利用するコンポーネント
 * 
 * 2.3（クラシエ）にて共通コンポーネントに改修を行ったため、微調整した
 * 詳細は organization/kracie/default/components/FilterGroupName.vue のdocを参照
 * 
 */

const props = defineProps({
  /**
   * Filter.selectable
   *
   * true: 選択可能
   * false: 選択不可、表示専用、凡例などヘルプ的な用途
   */
  selectable: {
    type: Boolean,
    required: false
  },
  /**
   * Filter.filter
   */
  filter: {
    type: Object,
    required: true
  },

  /**
   * 末端の子絞り込みにフリガナを付与するかどうか
   * trueだと 付与する
   *
   * MEMO
   * 2.2までは末端にはフリガナを付与できなかったが、2.3で付与できるように改修
   * 改修にあたり、2.2以前の環境に影響が出ないよう、明示的に有効化するPropsを用意した
   */
  showKanaLastChild: {
    type: Boolean,
    default: false
  }
})

/**
 * 末端の要素かの判定、末端であればtrueを返す
 */
const isLastChild = computed(() => {
  return !("children" in props.filter)
})

</script>

<style lang="scss" scoped>
.name {
  display: block;
  margin: 0;
  font-size: .875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 40px);
  &.with-ruby {
    font-size: 1rem;
  }
}
</style>
